package amazon.lastmile.inject

import app.nestbridge.app.ui.AppUiFactory
import com.slack.circuit.runtime.ui.Ui
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = AppUiFactory::class)
public interface AppNestbridgeAppUiAppUiFactory {
  @Provides
  @IntoSet
  public fun provideAppUiFactoryFactoryMultibinding(appUiFactory: AppUiFactory): Ui.Factory = appUiFactory
}
